"use strict";
import React from "react";
import reactUtils from "../../react_utils";
const bem = reactUtils.makeBem("invoice-action-bar");
function handler(f) {
  return (event) => {
    event.stopPropagation();
    event.preventDefault();
    f();
  };
}
export default React.createClass({
  getInitialState() {
    return {
      expanded: false
    };
  },
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: bem("__container"),
        onMouseEnter: this.expand,
        onMouseLeave: this.contract
      },
      this.actions()
    );
  },
  actions() {
    return this.props.actions.map(this.renderAction);
  },
  renderAction(action, i) {
    if (this.state.expanded) {
      return /* @__PURE__ */ React.createElement("div", { key: `action_button_${i}` }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--confirmation",
          onClick: handler(action.action)
        },
        action.label
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", { key: `action_link_${i}` }, /* @__PURE__ */ React.createElement("button", { className: "button", onClick: handler(action.action) }, action.label));
    }
  },
  expand(event) {
    this.setState({ expanded: true });
  },
  contract(event) {
    this.setState({ expanded: false });
  }
});
